import React from "react";
import Header from "../Shared/Header/Header";
import giffy1 from './Ekushey Bangla (4).gif';
import HomeMain from "./HomeMain/HomeMain";
import giffy2 from './Vertical Data Puzzle Infographic Graph.gif';
import './Home.css';

const Home = () => {
  return (
    <div>
      <Header></Header>
      <div className=" row mx-3" >
      <div className="col-lg-12 col-md-12 col-sm-12 ">
        <div className="card">
          <div className="row g-0">
            <div className="col-lg-6 col-md-6 col-sm-12 ">
            <img className="h-100 w-100 img-fluid" src={giffy1} alt="loading..." />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 ">
            <img className="h-100 w-100 img-fluid" src={giffy2} alt="loading..." />
            </div>
          </div>
        </div>
      </div>
      </div>
      <div className="mt-5">
      <HomeMain></HomeMain>
      </div>
    </div>
  );
};

export default Home;
